const intersection = (a1, a2) => a1.filter((v1) => a2.includes(v1));

export { intersection };
